export enum DirectionLocationType {
    LawsId = 0,
    LawsName = 1,
    Room = 2,
    Way = 3
}